// extracted by mini-css-extract-plugin
export default {"tableWrapper":"cH_k8","table":"cH_k9","mobileOnly":"cH_lb","hideDesktopRow":"cH_lc","home":"cH_ld","away":"cH_lf","draw":"cH_lg","cancelled":"cH_lh","circle":"cH_hy"};